// @ts-nocheck
import axios from "axios"
import endpoints from '../../config/endpoints.config'

const logout = async (accessToken: string) => {
    await axios.get(endpoints.auth.logout, {
        headers: { Authorization: accessToken },
        withCredentials: false
    })
}

export default logout